import { CockpitConfigurator } from './components/CockpitConfigurator';

const App = () => {
  const query = new URLSearchParams(window.location.search);

  const isInSpecialMode = query.get('mode')?.toLowerCase() === 'uieasy';
  const isInFinancesMode = query.get('mode')?.toLowerCase() === 'finances';

  return (
    <CockpitConfigurator
      isInSpecialMode={isInSpecialMode}
      isInFinancesMode={isInFinancesMode}
    />
  );
};

export default App;
